import { render, staticRenderFns } from "./balanceTab.vue?vue&type=template&id=e1446cb2&scoped=true&"
import script from "./balanceTab.vue?vue&type=script&lang=ts&"
export * from "./balanceTab.vue?vue&type=script&lang=ts&"
import style0 from "./balanceTab.vue?vue&type=style&index=0&id=e1446cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1446cb2",
  null
  
)

export default component.exports